const $wx = window.wx

let keyId = {
  data: function () {
    return {
      communityId: this.$route.query.communityId || '',
      serviceId: this.$route.query.serviceId || '',
      goodId: this.$route.query.goodId || '',
      popularizeInfo: this.$route.query.popularizeInfo || ''
    }
  },
  computed: {
    // serviceId () {
    //   return this.$route.query.serviceId
    // },
    // communityId: {
    //   get () {
    //     return this.$route.query.communityId || ''
    //   },
    //   set (val) {
    //     console.log(val)
    //   }
    // },
    // goodId () {
    //   return this.$route.query.goodId
    // }
    isMinPro () {
      return window.__wxjs_environment === 'miniprogram'
    }
  },
  mounted: function () {
    // this.$toast({
    //   message: JSON.stringify(this.$route.query)
    // })
    if (this.isMinPro && this.popularizeInfo) {
      // console.log('===================savePopularizeInfo===================')
      $wx.miniProgram.postMessage({
        data: {
          event: 'savePopularizeInfo',
          popularizeInfo: this.popularizeInfo
        }
      })
    }
  }
}
export default keyId
